import React from 'react';
import { useAuth } from '../context/AuthContext';
import { FiUser, FiMail, FiCalendar } from 'react-icons/fi';

const Profile = () => {
  const { user } = useAuth();

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  return (
    <div className="container-custom py-8">
      <div className="max-w-3xl mx-auto">
        <h1 className="text-3xl font-bold mb-8">My Profile</h1>

        <div className="bg-white rounded-lg shadow-md overflow-hidden">
          {/* Profile Header */}
          <div className="bg-primary-600 px-6 py-8 text-white">
            <div className="flex items-center space-x-4">
              <div className="w-20 h-20 bg-white rounded-full flex items-center justify-center">
                <FiUser className="w-10 h-10 text-primary-600" />
              </div>
              <div>
                <h2 className="text-2xl font-semibold">{user?.email?.split('@')[0]}</h2>
                <p className="text-primary-100">Member</p>
              </div>
            </div>
          </div>

          {/* Profile Details */}
          <div className="p-6 space-y-4">
            <div className="flex items-center space-x-3 p-3 bg-gray-50 rounded-lg">
              <FiMail className="w-5 h-5 text-gray-500" />
              <div>
                <p className="text-sm text-gray-500">Email</p>
                <p className="text-gray-900">{user?.email}</p>
              </div>
            </div>

            <div className="flex items-center space-x-3 p-3 bg-gray-50 rounded-lg">
              <FiCalendar className="w-5 h-5 text-gray-500" />
              <div>
                <p className="text-sm text-gray-500">Member Since</p>
                <p className="text-gray-900">
                  {user?.created_at ? formatDate(user.created_at) : 'N/A'}
                </p>
              </div>
            </div>

            <div className="flex items-center space-x-3 p-3 bg-gray-50 rounded-lg">
              <div className="w-2 h-2 rounded-full bg-green-500"></div>
              <div>
                <p className="text-sm text-gray-500">Account Status</p>
                <p className="text-gray-900">Active</p>
              </div>
            </div>
          </div>

          {/* Account Actions */}
          <div className="border-t px-6 py-4 bg-gray-50">
            <h3 className="font-semibold mb-3">Account Actions</h3>
            <div className="space-y-2">
              <button className="text-primary-600 hover:text-primary-700 block">
                Change Password
              </button>
              <button className="text-red-600 hover:text-red-700 block">
                Delete Account
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;